import { axiosInstance as axios } from "./axiosManager"
import { joinRoom, socket } from "../tool/socketIO"
import { DefaultPrompt } from '../../src/component/chat/AIChat/DefaultPrompt'



const sessionUrl = process.env.REACT_APP_HOST_API + "/sessions"
const userUrl = process.env.REACT_APP_HOST_API + "/users"
const instructorUrl = process.env.REACT_APP_HOST_API + "/instructors"
const groupUrl = process.env.REACT_APP_HOST_API + "/groups"
const codeUrl = process.env.REACT_APP_HOST_API + "/codes"

export const getSessionById = async (id) => {
	if (!id) return null
	let session
	await axios
		.get(sessionUrl + "/" + id)
		.then((response) => {
			session = response.data.session
		})
		.catch((error) => {
			throw error
		})
	return session
}

export const getSessionTasksByCreaterId = async (createrId) => {
	if (!createrId) return null
	let tasks
	await axios
		.get(sessionUrl + "/tasks/createrId/" + createrId)
		.then((response) => {
			tasks = response.data.tasks
		})
		.catch((error) => {
			throw error
		})
	return tasks
}

export const updateTaskInSession = async (sessionId, task) => {
	if (!sessionId || !task) {
		return false
	}
	try {
		return await axios
			.put(sessionUrl + "/" + sessionId, {
				session: {
					task: task,
				},
			})
	}
	catch (error) {
		console.error(error)
		return false
	}
}

export const IncrementStuNumInSession = async (sessionId) => {
	if (!sessionId) {
		return false
	}
	try {
		return await axios
			.post(sessionUrl + "/incStu/" + sessionId)
	}
	catch (error) {
		console.error(error)
		return false
	}
}

export const DecrementActiveStuNumInSession = async (sessionId) => {
	if (!sessionId) {
		return false
	}
	try {
		return await axios
			.post(sessionUrl + "/decActiveStu/" + sessionId)
	}
	catch (error) {
		console.error(error)
		return false
	}
}

export const addQuizInSession = async (sessionId, quiz) => {
	if (!sessionId || !quiz) {
		return false
	}
	try {
		return await axios
			.put(sessionUrl + "/" + sessionId, {
				session: {
					quiz: quiz,
				},
			})
	}
	catch (error) {
		console.error(error)
		return false
	}
}
export const updateAIPromptsInSession = async (sessionId, prompts) => {
	if (!sessionId || !prompts) {
		return false
	}
	try {
		return await axios
			.put(sessionUrl + "/" + sessionId, {
				session: {
					ai_prompts: prompts,
				},
			})
	}
	catch (error) {
		console.error(error)
		return false
	}
}



export const setEnableQuizInSession = async (sessionId, quizEnable) => {
	if (!sessionId || quizEnable === undefined) {
		return false
	}
	try {
		return await axios
			.put(sessionUrl + "/" + sessionId, {
				session: {
					enable_quiz: quizEnable,
				},
			}).then((response) => {
				return response.data.session[1][0].enable_quiz
			})
	}
	catch (error) {
		console.error(error)
		return false
	}
}

export const setCorrectAnswersSeesion = async (sessionId, correctAnswers) => {
	if (!sessionId || !correctAnswers) {
		return false
	}
	try {
		return await axios
			.put(sessionUrl + "/" + sessionId, {
				session: {
					correct_answers: correctAnswers,
				},
			}).then((response) => {
				return response.data.session[1][0].coorect_answers
			})
	} catch (error) {
		console.error(error)
		return false
	}
}

export const addSession = async (crn, task, subject, type, creater_id, creater_uid, quiz) => {
	const guiSessionTypes = ["HTML", "CSS", "JavaScript", "Mixed", "JSBin", "InitialFinal", "InitialFinalCSS", "InitialFinalJS"]
	const newSession = {
		time: new Date(),
		crn: crn,
		creater_id: creater_id,
		creater_uid: creater_uid,
		task: task,
		subject: subject,
		enable_chat: type === "Vizmental" || type === "Helper/Helpee" || type === "Audio" || type.startsWith("SQL") || guiSessionTypes.includes(type) ? true : false,
		grouped: type === "Helper/Helpee" || type === "Audio" ? true : false,
		stu_num: 0,
		active_stu: 0,
		group_round: 0,
		regrouping: false,
		type: type,
		ai_prompts: type === "Vizmental" ? DefaultPrompt : null,
	}
	// Pop Quiz sessions store their authored questions here. This reuses the same JSONB
	// column regular coding sessions use for their function-comprehension quiz
	// (TaskCard.jsx/DescriptionQuizModal.jsx), but with a different shape ({questions: [{
	// text, choices, correctIndex}]} vs {multipleChoice, unitTests, functionName, hint}) -
	// safe because those readers only ever render for a Vizmental/Audio session with
	// enable_quiz on, never for a Pop Quiz session.
	if (type === "Pop Quiz" && quiz) {
		newSession.quiz = quiz
	}

	const response = await axios.post(sessionUrl, {
			session: newSession,
		})
	return response.data.session
}

export const getUsersSortedByProgress = async (session) => {
	if (!session) return []
	let toReturn = null
	await axios
		.get(userUrl + "/session/" + session.id)
		.then((response) => {
			//console.log(response)
			toReturn = response.data
		})
		.catch((error) => {
			console.error(error)
			toReturn = []
		})
	return toReturn
}

export const getActiveUserIDInSession = async (session) => {
	try {
		const response = await axios.get(userUrl + "/active/session/" + session.id)
		const activeUsers = response.data.users.map(user => ({
			socketId: user[0],
			userId: user[1].userId,
			sessionId: user[1].sessionId
		}))
		return activeUsers
	} catch (error) {
		console.error(error)
		return []
	}
}

export const groupingInSession = async (session, type, baseGroupSize = 3) => {
	if (baseGroupSize <= 0) return false

	try {
		const response = await axios.post(
			sessionUrl + "/" + session.id + "/grouping", {
			"type": type,
		}
		)
		return response.data.groups !== null
	} catch (error) {
		console.error(error)
		return false
	}
}

export const regrouping = async (session, baseGroupSize) => {
	if (baseGroupSize <= 0) return false

	try {
		const response = await axios.post(
			sessionUrl + "/" + session.id + "/regroup", {
			"baseGroupSize": baseGroupSize,
			"round": 2
		}
		)

		console.log("regrouping", response)
		return response.data.groups

	} catch (error) {
		console.error(error)
		return false
	}
}

export const groupManual = async (session, userIds, name) => {
	//console.log(session.id)
	//console.log(userIds)
	//console.log(name)
	try {
		const response = await axios.post(
			sessionUrl + "/" + session.id + "/groupManual", {
			"ids": userIds,
			"name": name
		}
		)
		return response.data.groups !== null
	} catch (error) {
		console.error(error)
		return false
	}
}

export const addToGroup = async (session, userId) => {
	console.log(session.id)
	console.log(userId)
	try {
		const response = await axios.post(
			sessionUrl + "/" + session.id + "/lateGroup", {
			"id": userId,
		}
		)
		return response.data.groups
	} catch (error) {
		console.error(error)
		return false
	}
}

export const quitSession = async (userId) => {
	if (!userId) return null
	await axios.put(instructorUrl + "/" + userId, {
		instructor: {
			id: userId,
			current_session: null,
		},
	})
}

export const quitSessionStudent = async (userId) => {
	if (!userId) return null
	await axios.put(userUrl + "/" + userId, {
		user: {
			id: userId,
			session_id: null,
		},
	})
}

export const getSessionsByUserId = async (userId) => {
	if (!userId) return []
	let sessions = []
	await axios.get(sessionUrl + "/user/" + userId)
		.then((response) => {
			sessions = response.data.sessions
		})
		.catch((error) => {
			console.error(error)
			return []
		})
	return sessions
}

export const getSessionsByCreatorId = async (creatorId) => {
	if (!creatorId) return []
	try {

	  const response = await axios.get(sessionUrl + `/creator/${creatorId}`)
	  console.log(response.data)
	  return response.data
	} catch (error) {
	  console.error("Error in getSessionsByCreatorId:", error)
	  return []
	}
  }
  

export const getSessionsByIds = async (sessionIds) => {
	if (!sessionIds) return []
	let sessions = []
	await axios
		.post(sessionUrl + "/ids", {
			ids: sessionIds,
		})
		.then((response) => {
			sessions = response.data
		})
		.catch((error) => {
			console.error(error)
			return []
		})
	return sessions
}

export const setSessionEnableChat = async (sessionId, enableChat) => {
	if (!sessionId || enableChat === undefined) return false
	axios
		.put(sessionUrl + "/" + sessionId, {
			session: {
				enable_chat: enableChat,
			},
		})
		.then((response) => {
			return response.data.session[1][0].enable_chat
		})
		.catch((error) => {
			console.error(error)
			return false
		})
}

export const setSessionRegrouping = async (sessionId, regrouping) => {
	if (!sessionId || regrouping === undefined) return false
	axios
		.put(sessionUrl + "/" + sessionId, {
			session: {
				regrouping: regrouping,
			},
		})
		.then((response) => {
			return response.data.session[1][0].regrouping
		})
		.catch((error) => {
			console.error(error)
			return false
		})
}

export const setSessionGroupRound = async (sessionId, group_round) => {
	if (!sessionId || group_round === undefined) return false
	axios
		.put(sessionUrl + "/" + sessionId, {
			session: {
				group_round: group_round,
			},
		})
		.then((response) => {
			return response.data.session[1][0].group_round
		})
		.catch((error) => {
			console.error(error)
			return false
		})
}

export const removeGroupingInSession = async (session) => {
	try {
		const response = await axios.delete(groupUrl + "/session/" + session.id)
		return response.data.groupsRemoved
	} catch (error) {
		throw error
	}
}

export const getCodeByUser = async (userId) => {
	if (!userId) {
		return null
	}
	axios
		.get(codeUrl + "/user/" + userId)
		.then((response) => {
			return response.data
		})
		.catch((error) => {
			console.error(error)
			return null
		})
}

export const deleteSession = async (sessionId) => {
	if (!sessionId) return false
	try {
		await axios.delete(sessionUrl + "/" + sessionId)
		return true
	} catch (error) {
		console.error(error)
		return false
	}
}

export const updateTestInSession = async (sessionId, test) => {
	if (!sessionId || !test) {
		//console.log("can't update")
		return false
	}

	axios
		.put(sessionUrl + "/" + sessionId, {
			session: {
				test_cases: test,
			},
		})
		.then((response) => {
			return true
		})
		.catch((error) => {
			console.error(error)
			return false
		})
}

export const updateIdentityListInSession = async (sessionId, identityList) => {
	if (!sessionId || !identityList) {
		//console.log("Can't update, sessionId or testList is missing.")
		return false
	}

	const session = {
		identity_list: identityList,
	}
	try {
		await axios.put(sessionUrl + "/" + sessionId, {
			session: session,
		})

		return true
	} catch (error) {
		console.error("Error updating identityList:", error)
		return false
	}
}

export const updateStarterCodeInSession = async (sessionId, starterCode) => {
	if (!sessionId || !starterCode) {
		//console.log("can't update")
		return false
	}

	axios
		.put(sessionUrl + "/" + sessionId, {
			session: {
				test_code: starterCode,
			},
		})
		.then((response) => {
			return true
		})
		.catch((error) => {
			console.error(error)
			return false
		})
}

export const addUserToSession = async (sessionId, userName) => {
	if (!sessionId || !userName) {
		//console.log("can't update")
		return false
	}
}

export const generateUserInSession = async (sessionId) => {
	if (!sessionId) {
		//console.log("can't update")
		return false
	}
	for (let i = 0; i < 10; i++) {
		addUserToSession(sessionId, "user" + i)
	}
}

export const checkUserInSession = async (sessionId, userId) => {
	axios
		.get(userUrl + userId)
		.then((response) => {
			if (response.data.session_id === sessionId) {
				return true
			}
			return false
		})
		.catch((error) => {
			return false
		})
}

export const subscribeSession = (sessionId, updateSession, userID = null) => {
    console.log("subscribing to session", sessionId)

    const handleUpdateSession = (res) => {
        console.log("Socket Update:", res)
        updateSession(res.data)
    }
    
    const handleDisconnect = () => {
        console.log("disconnected from session service")
    }

    // Sent again after a reconnect, which leaves the server's new connection in no room.
    const leaveRoom = joinRoom("subscribe session", sessionId, userID)
    socket.on("update session", handleUpdateSession)
    socket.on("disconnect", handleDisconnect)

    return () => {
        leaveRoom()
        socket.off("update session", handleUpdateSession)
        socket.off("disconnect", handleDisconnect)
        socket.emit("unsubscribe session", sessionId)
    }
}

export const duplicateSession = async (sessionId, newSubject) => {
	try {
		let res = await axios.post(sessionUrl + "/" + sessionId + "/duplicate", {
			"subject": newSubject
		})
		return res.data.session
	} catch (error) {
		console.error(error)
		return null
	}
}

export const getAllTopicsInSession = async (sessionId) => {
	try {
		const res = await axios.get(sessionUrl + "/" + sessionId + "/topics")
		return res.data
	} catch (error) {
		console.error(error)
		return []
	}
}

export const renewTopics = async (sessionId) => {
	try {
		return await axios.get(sessionUrl + "/" + sessionId + "/renewTopics")
	} catch (error) {
		console.error(error)
	}
}
export const setSessionEnableChatAndCloseSession = async (sessionId, enableChat, closeSessionType) => {
	if (!sessionId || enableChat === undefined) return false

	try {
		const response1 = await axios.put(sessionUrl + "/" + sessionId, {
			session: {
				enable_chat: enableChat,
				closeSessionType: closeSessionType || null,
			},
		})
		await axios.put(sessionUrl + "/" + sessionId + "/endChat", {
			closeSessionType: closeSessionType
		})
		return response1?.data?.session?.[1]?.[0]?.enable_chat ?? false;
	} catch (error) {
		console.error(error)
		return false
	}
}
export const getEventsBySessionId = async (sessionId) => {
	if (!sessionId) return null
	try {
		const response = await axios.get(sessionUrl + "/" + sessionId + "/events")
		return response.data
	} catch (error) {
		console.error(error)
		return null
	}
}

export const joinSession = async (sessionId, userId, uid) => {
	if (!sessionId || !userId || !uid) return false

	try {
		const response = await axios.post(`${sessionUrl}/join/${sessionId}`, {
			userId,
			uid
		})
		return response.data
	} catch (error) {
		return false
	}
}

// Like joinSession, but says why it did not write a row: 'joined', 'already-joined' (the
// backend's 400 for a user it already has in this session - e.g. one who joined earlier on
// /session/:id), 'no-account' (guests have no uid, so there is no user_session row to
// write) or 'failed'.
export const joinSessionResult = async (sessionId, userId, uid) => {
	if (!sessionId || !userId) return 'failed'
	if (!uid) return 'no-account'
	try {
		await axios.post(`${sessionUrl}/join/${sessionId}`, { userId, uid })
		return 'joined'
	} catch (error) {
		const message = error?.response?.data?.message || ''
		if (error?.response?.status === 400 && /already registered/i.test(message)) return 'already-joined'
		return 'failed'
	}
}

export const getSessionsByCRN = async (crn) => {
	try {
	  const response = await axios.get(sessionUrl + `/crn/${crn}`)
	  return response.data
	} catch (error) {
	  console.error("Error in getSessionsByCRN:", error)
	  return []
	}
  }

// Generic partial update, following the same PUT /sessions/:id pattern as
// updateSessionStatus below - used by PopQuizEditor to save the quiz title/questions
// without needing a dedicated endpoint per field.
export const updateSessionFields = async (sessionId, fields) => {
  if (!sessionId || !fields) return false
  try {
    await axios.put(sessionUrl + "/" + sessionId, {
      session: fields
    })
    return true
  } catch (error) {
    console.error(error)
    return false
  }
}

// The AI Chat Policy is not part of the session object (the backend keeps it out of every
// ordinary session read so it never reaches students). Instructors read and write it
// through these endpoints, which check the signed-in user's role server-side.
// Resolve to { ok, policy } - ok:false on any failure, never throws.
export const getAiChatPolicy = async (sessionId) => {
	if (!sessionId) return { ok: false, policy: null }
	try {
		const response = await axios.get(sessionUrl + "/" + sessionId + "/ai-chat-policy")
		return { ok: true, policy: response.data?.ai_chat_policy ?? null }
	} catch (error) {
		console.error(error)
		return { ok: false, policy: null, status: error?.response?.status }
	}
}

export const saveAiChatPolicy = async (sessionId, policy) => {
	if (!sessionId) return { ok: false, policy: null }
	try {
		const response = await axios.put(sessionUrl + "/" + sessionId + "/ai-chat-policy", {
			ai_chat_policy: policy,
		})
		return { ok: true, policy: response.data?.ai_chat_policy ?? null }
	} catch (error) {
		console.error(error)
		return { ok: false, policy: null, status: error?.response?.status }
	}
}

export const updateSessionStatus = async (sessionId, status) => {
  if (!sessionId || !status) return false
  try {
    await axios.put(sessionUrl + "/" + sessionId, {
      session: { status }
    })
    return true
  } catch (error) {
    console.error(error)
    return false
  }
}
  
  

// Function to get a list of colleges (NEEDS TO BE UPDATED LATER)
export const getColleges = async () => {
	return ['Virginia Tech']; // Hard-coded list of colleges
};

// Function to get available CRNs (NEEDS TO BE UPDATED LATER)
export const getAvailableCRNs = async () => {
	return ['83596', '13290', '13292', '13293']; // Hard-coded list of CRNs (for now, will pull from sessions table eventually )
};
